// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_5c-2";
export var blackBorderOnHover = "_5c-7";
export var cell = "_5c-6";
export var cellContainer = "_5c-3";
export var checked = "_5c-8";
export var disabled = "_5c-5";
export var featuredIconCellContainer = "_5c-9";
export var featuredIconTextContainer = "_5c-b";
export var featuredIconWrapper = "_5c-a";
export var noBorder = "_5c-c";
export var orangeSelectedRow = "_cv-3";
export var overflowableText = "_5c-0";
export var overflowableTextContainer = "_5c-1";
export var row = "_5d-0";
export var rowCheckboxCell = "_5c-4";
export var selectableTable = "_cv-2";